// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-privacy-policy>h2{font-size:var(--fs-600);margin-bottom:calc(var(--fs-700)*1.5)}.c-privacy-policy>h3{font-size:var(--fs-500);margin:var(--fs-700) 0}.c-privacy-policy>p{font-size:var(--fs-400)}.c-privacy-policy>p>a{color:#36ae37;text-decoration:underline}.c-privacy-policy ol>li,.c-privacy-policy ul>li{font-size:var(--fs-400)}.c-privacy-policy ul{margin-left:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
